import dayjs from 'dayjs'

export const mockMedication = {
  id: 'med-123',
  name: 'Paracetamol 500mg',
  stockQuantityType: 'tablets',
  quantityType: 'tablets',
  currentStock: 45,
  expectedStock: 50,
  lowStockThreshold: 10
}

export const mockResident = {
  id: 'resident-123',
  name: {
    first: 'John',
    last: 'Smith'
  }
}

export const mockLogs = [
  {
    id: 'log-1',
    timeLogged: dayjs().subtract(2, 'days').toISOString(),
    amount1: 50,
    amount2: 50,
    action: 'Comment',
    actionType: 'comment' as const,
    title: 'Comment',
    subtitle: 'Medication review note',
    description: 'Added note about medication effectiveness',
    hasDiscrepancy: false,
    loggedBy: {
      id: 'user-1',
      name: {
        first: 'Sarah',
        last: 'Johnson'
      },
      picture:
        'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-2',
    timeLogged: dayjs().subtract(1, 'day').toISOString(),
    amount1: 45,
    amount2: 50,
    action: 'Stock Count',
    actionType: 'stock-count' as const,
    title: 'Stock Count',
    subtitle: 'Discrepancy detected',
    description: 'Stock count after medication administration',
    hasDiscrepancy: true,
    isResolved: false,
    loggedBy: {
      id: 'user-2',
      name: {
        first: 'Mike',
        last: 'Wilson'
      },
      picture:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-3',
    timeLogged: dayjs().subtract(7, 'hours').toISOString(),
    amount1: 40,
    amount2: 50,
    action: 'Disposal',
    actionType: 'disposal' as const,
    title: 'Disposal',
    subtitle: '5 tablets disposed',
    description: 'Medication disposal due to expiry',
    loggedBy: {
      id: 'user-3',
      name: {
        first: 'Emma',
        last: 'Davis'
      },
      picture:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-4',
    timeLogged: dayjs().subtract(3, 'hours').toISOString(),
    amount1: 60,
    amount2: 50,
    action: 'Delivery',
    actionType: 'delivery' as const,
    title: 'New Delivery',
    subtitle: '20 tablets received',
    description: 'New medication delivery received',
    loggedBy: {
      id: 'user-4',
      name: {
        first: 'James',
        last: 'Brown'
      },
      picture:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-5',
    timeLogged: dayjs().subtract(1, 'hour').toISOString(),
    amount1: 55,
    amount2: 50,
    action: 'Administration',
    actionType: 'administration' as const,
    title: 'Administration',
    subtitle: '5 tablets administered',
    description: 'Medication administered to resident',
    loggedBy: {
      id: 'user-5',
      name: {
        first: 'Lisa',
        last: 'Garcia'
      },
      picture:
        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-6',
    timeLogged: dayjs().subtract(30, 'minutes').toISOString(),
    amount1: 55,
    amount2: 50,
    action: 'Comment',
    actionType: 'comment' as const,
    title: 'Comment',
    subtitle: 'Medication review note',
    description: 'Added note about medication effectiveness',
    loggedBy: {
      id: 'user-6',
      name: {
        first: 'Dr. Robert',
        last: 'Taylor'
      },
      picture:
        'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  },
  {
    id: 'log-7',
    timeLogged: dayjs().subtract(2, 'hours').toISOString(),
    amount1: 48,
    amount2: 50,
    action: 'Stock Count',
    actionType: 'stock-count' as const,
    title: 'Stock Count',
    subtitle: 'Discrepancy resolved',
    description: 'Stock count discrepancy was resolved after investigation',
    hasDiscrepancy: true,
    isResolved: true,
    resolveMessage:
      'Stock count was verified and corrected after physical inventory check',
    loggedBy: {
      id: 'user-7',
      name: {
        first: 'Anna',
        last: 'Martinez'
      },
      picture:
        'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face'
    },
    deleted: false
  }
]
